import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import loadOrderByOrderNumber from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain, DispatchLoadOrderIfNeeded, DispatchSetOrderNumber } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/DisplayOrder";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    { orderNumber: string; expand?: ("orderLines" | "shipments" | "vmidetails")[], customerNumber?: string; },
    GetOrderApiParameter,
    OrderModel
>;

export const DispatchSetOrderNumberExtension: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderDetails/SetOrderNumber",
        orderNumber: props.parameter.orderNumber,
    });
};

export const DispatchLoadOrderIfNeededExtension: HandlerType = props => {
    const orderState = getOrderState(props.getState(), props.parameter.orderNumber);
    if (!orderState.isLoading) {
        props.dispatch(loadOrderByOrderNumber(props.parameter));
    }
};


replaceInChain(chain, DispatchSetOrderNumber, DispatchSetOrderNumberExtension);
replaceInChain(chain, DispatchLoadOrderIfNeeded, DispatchLoadOrderIfNeededExtension);